import { Skeleton, Grid, GridItem, Flex, Box } from "@chakra-ui/react";

export default function PocsSkeleton() {
  return (
    <>
      <Grid
        zIndex={9}
        gap={{ base: "0px", "2xl": "10px", "3xl": "30px" }}
        templateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(2, 1fr)",
          lg: "repeat(3, 1fr)",
        }}
      px={{ base: "20px", "2xl": "120px", "5xl": "450px" }}
      >
        <GridItem>
          <Box
            //   cursor="pointer"
            mt="40px"
            width={{ base: "300px", md: "379px" }}
            // width="100%"
            mx={{ base: "10px" }}
            borderWidth="1px"
            borderRadius="10px"
            overflow="hidden"
            shadow="md"
            p="5px"
            bgColor={"#FFF"}
            // pb="40px"
            h="auto"
            as={Flex}
            flexDirection={"column"}
          >
            <Flex
              h="192px"
              position={"relative"}
              w="full"
              flex={"column"}
            >
                <Skeleton height='100%' w={"100%"} />
            </Flex>
            <Box p="14px">
            <Skeleton height='20px' w={"100%"} />
            <Skeleton height='40px' my="10px" w={"100%"} />

            <Flex justifyContent={"space-between"} alignItems={"center"}>
            <Skeleton height='20px' w={"50px"} />
            <Flex alignItems="center" gap={"12px"} justifyContent="end">
            <Skeleton height='20px' w={"50px"} />
            <Skeleton height='20px' w={"50px"} />

            </Flex>
                
            </Flex>


            </Box>
          </Box>
        </GridItem>
        <GridItem>
          <Box
            //   cursor="pointer"
            mt="40px"
            width={{ base: "300px", md: "379px" }}
            // width="100%"
            mx={{ base: "10px" }}
            borderWidth="1px"
            borderRadius="10px"
            overflow="hidden"
            shadow="md"
            p="5px"
            bgColor={"#FFF"}
            // pb="40px"
            h="auto"
            as={Flex}
            flexDirection={"column"}
          >
            <Flex
              h="192px"
              position={"relative"}
              w="full"
              flex={"column"}
            >
                <Skeleton height='100%' w={"100%"} />
            </Flex>
            <Box p="14px">
            <Skeleton height='20px' w={"100%"} />
            <Skeleton height='40px' my="10px" w={"100%"} />

            <Flex justifyContent={"space-between"} alignItems={"center"}>
            <Skeleton height='20px' w={"50px"} />
            <Flex alignItems="center" gap={"12px"} justifyContent="end">
            <Skeleton height='20px' w={"50px"} />
            <Skeleton height='20px' w={"50px"} />

            </Flex>
                
            </Flex>


            </Box>
          </Box>
        </GridItem>
        <GridItem>
          <Box
            //   cursor="pointer"
            mt="40px"
            width={{ base: "300px", md: "379px" }}
            // width="100%"
            mx={{ base: "10px" }}
            borderWidth="1px"
            borderRadius="10px"
            overflow="hidden"
            shadow="md"
            p="5px"
            bgColor={"#FFF"}
            // pb="40px"
            h="auto"
            as={Flex}
            flexDirection={"column"}
          >
            <Flex
              h="192px"
              position={"relative"}
              w="full"
              flex={"column"}
            >
                <Skeleton height='100%' w={"100%"} />
            </Flex>
            <Box p="14px">
            <Skeleton height='20px' w={"100%"} />
            <Skeleton height='40px' my="10px" w={"100%"} />

            <Flex justifyContent={"space-between"} alignItems={"center"}>
            <Skeleton height='20px' w={"50px"} />
            <Flex alignItems="center" gap={"12px"} justifyContent="end">
            <Skeleton height='20px' w={"50px"} />
            <Skeleton height='20px' w={"50px"} />

            </Flex>
                
            </Flex>


            </Box>
          </Box>
        </GridItem>
      </Grid>
    </>
  );
}
